import { render, staticRenderFns } from "./ProfileAdvanceSettings.vue?vue&type=template&id=da203dc4"
import script from "./ProfileAdvanceSettings.vue?vue&type=script&lang=js"
export * from "./ProfileAdvanceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports